import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './components/app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// The legacy components update state from async callbacks, so they rely on zone-based change detection.
platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })] })
  .catch(error => console.error(error));